import App from "./Contesa.svelte";
const initConfig = {
    mainTitle: "Customise Contesa",
    bookADemoHref: "https://accora.care/book-a-join-visit",
};
export const ContesaConfigurator = (targetId, config) => {
    const app = new App({
        target: document.getElementById(targetId),
        props: {
            config: Object.assign(Object.assign({}, initConfig), config),
        },
    });
    return app;
};
window.ContesaConfigurator = ContesaConfigurator;
export default ContesaConfigurator;
